import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useToast } from 'primevue/usetoast'
import { usePermissionStore } from '@/store/permissionsStore'
import axios from 'axios'
import 'jspdf-autotable';
import CryptoJS from 'crypto-js';
import { useDbCountStore } from '@/store/admin/DashboardCountStore'


export const useAuthStore = defineStore('auth', () => {


  const isAuthenticated = ref(false)
  let usernamex = ref('')
  let userType = ref('')
  let teeacherid = ref('')
  let parentid = ref('')
  const token = ref('')
  const roles = ref([])
  const isAdmin = ref(false)
  const isSuperAdmin = ref(false)
  const user_pid = ref('')
  const logedname = ref('')
  const school_id = ref('')
  const staff_pid = ref('')
  const parent_pid = ref('')

  const useAuthStore = usePermissionStore()

  const hash = ref('');



  function hashText(text) {
    // Use the global CryptoJS object
     return CryptoJS.SHA256(text).toString(CryptoJS.enc.Hex);
  }


  // ✅ Load authentication state from sessionStorage (instead of localStorage)
  isAuthenticated.value = JSON.parse(sessionStorage.getItem('isAuthenticated')) || false
  isAdmin.value = JSON.parse(sessionStorage.getItem('isAdmin')) || false
  isSuperAdmin.value = JSON.parse(sessionStorage.getItem('isSuperAdmin')) || false

  logedname.value = JSON.parse(sessionStorage.getItem('logedname'))
  usernamex.value = JSON.parse(sessionStorage.getItem('username'))

  user_pid.value = JSON.parse(sessionStorage.getItem('user_pid'))
  userType.value = JSON.parse(sessionStorage.getItem('userType'))
  school_id.value = JSON.parse(sessionStorage.getItem('school_id')) || ''
  roles.value = JSON.parse(sessionStorage.getItem('roles')) || []
  token.value = sessionStorage.getItem('token') || ''

  staff_pid.value = sessionStorage.getItem('staff_pid') || ''
  parent_pid.value = sessionStorage.getItem('parent_pid') || ''




  const login = async (username, password) => {
   if (username.includes('@')) {


const sampleText = "Hello, world!";
const hashedValue = hashText(sampleText);

      // Attempt login with API if email format is detected

      const macAdd = ref('')
      const ipAdd = ref('')

      // macAdd.value = await getMac()
      // ipAdd.value = await getIPAddress()

      // headers: {
      //   'Content-Type': 'application/json',
      //   'ip': 'X_' + ipAdd.value + '_ADDRESS',
      //   'mac': 'X_' + macAdd.value + '_ADDRESS',
      //   'Authorization': `Bearer ${token.value}`
      // },

      return axios
        .post(
          `${import.meta.env.VITE_HOST_API}/api/user/login`,
          {
            email: username,
            password: password,
            signature: hashText(username + password)
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then( async (response) => {

          const data = response.data


      const dbStore = useDbCountStore()

      //check your ip and email if valid for admin checking only
      const response1 = await dbStore.getStudentCount(data.user.pid, '')
      if (response1.response?.data.message.includes('Your IP address')){
          return { success: false, data: 'landing', message: response1.response?.data.message}
      }
      else if(response1.response?.data.message.includes('Your email is restricted to use this api.')){
          return { success: false, data: 'landing', message: response1.response?.data.message}
      }

      else{


          if (!data.user.type.includes('Admin')) {
            roles.value = data.roles
            sessionStorage.setItem('roles', JSON.stringify(data.roles))
            token.value = data.token
            sessionStorage.setItem('token', data.token)

            isAuthenticated.value = true
            usernamex.value = username
            logedname.value = data.user.name



            sessionStorage.setItem('logedname', JSON.stringify(data.user.name))
            sessionStorage.setItem('isAuthenticated', JSON.stringify(true))
            sessionStorage.setItem('username', JSON.stringify(username))
            school_id.value = data.school.id
            sessionStorage.setItem('school_id', JSON.stringify(data.school.id || ''))
            if (!school_id.value){
            school_id.value = data.school[0].id
            sessionStorage.setItem('school_id', JSON.stringify(data.school[0].id || ''))
            }
            userType.value = data.user.type
            sessionStorage.setItem('userType', JSON.stringify(data.user.type))
            user_pid.value = data.user.pid

            sessionStorage.setItem('user_pid', JSON.stringify(data.user.pid))
            isAdmin.value = false
            isSuperAdmin.value = false
            sessionStorage.setItem('isSuperAdmin', JSON.stringify(false))
            sessionStorage.setItem('isAdmin', JSON.stringify(false))

            staff_pid.value = data.staff_pid
            sessionStorage.setItem('staff_pid', JSON.stringify(data.staff_pid))

            parent_pid.value = data.parent_pid
            sessionStorage.setItem('parent_pid', JSON.stringify(data.parent_pid))
          } else {

            roles.value = data.roles
            sessionStorage.setItem('roles', JSON.stringify(data.roles))
            token.value = data.token
            sessionStorage.setItem('token', data.token)

            isAuthenticated.value = true
            school_id.value = data.school.id
            sessionStorage.setItem('school_id', JSON.stringify(data.school.id || ''))
            usernamex.value = username
            logedname.value = data.user.name

            sessionStorage.setItem('logedname', JSON.stringify(data.user.name))
            sessionStorage.setItem('isAuthenticated', JSON.stringify(true))
            sessionStorage.setItem('username', JSON.stringify(username))
            userType.value = data.user.type
            sessionStorage.setItem('userType', JSON.stringify(data.user.type))
            user_pid.value = data.user.pid

            staff_pid.value = data.staff_pid
            sessionStorage.setItem('staff_pid', JSON.stringify(data.staff_pid))

            sessionStorage.setItem('user_pid', JSON.stringify(data.user.pid))
            isAdmin.value = true
            if (data.user.type === 'Super Admin'){
            isSuperAdmin.value = true
            sessionStorage.setItem('isSuperAdmin', JSON.stringify(true))
            }
            sessionStorage.setItem('isAdmin', JSON.stringify(true))

          }

          return { success: true, data: response}
      }
        })
        .catch((error) => {
          console.error('Login failed:', error.response.data.message)
          return { success: false, data: 'landing', message : error.response.data.message}
        })
    }

    return false
  }

  // Function to get the IP address
  async function getIPAddress() {
    try {
      // Using a public API to get IP address
  const response = await fetch('https://api.ipify.org?format=json')
  const data = await response.json()
  return data.ip
    } catch (error) {
      console.error('Error getting IP address:', error)
      return null
    }
  }

  async function getMac() {
    try {
      const response = await fetch('http://localhost:3000/mac-address')
      const data = await response.json()
      return data.macAddresses[0].mac
    } catch (error) {
      console.error('Error getting IP address:', error)
      return null
    }
  }

  const logout = () => {
    isAuthenticated.value = false
    isAdmin.value = false
    sessionStorage.removeItem('isAuthenticated') // ✅ Clear session state
  }

  return {
    isAuthenticated: computed(() => isAuthenticated.value),
    usernamex,
    userType,
    isAdmin,
    roles,
    user_pid,
    staff_pid,
    logedname,
    getIPAddress,
    token,
    school_id,
    isSuperAdmin,
    login,
    logout,
    hashText,
    parent_pid
  }
})
